export enum TypeCodePostalEnum {
    OUTREMER = 'OUTREMER',
    METROPOLE = "METROPOLE"
}
